(function () {
    'use strict';
    angular.module('wamasysApp').factory('EquipmentParc', EquipmentParc);
    EquipmentParc.$inject = ['$http', '$window'];
    function EquipmentParc($http, $window) {
        var root = 'api/equipment-parc/';
        return {
            newUuid: function () { var bytes = new $window.Uint8Array(16); $window.crypto.getRandomValues(bytes); bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128; return Array.prototype.map.call(bytes, function (b, i) { return ([4, 6, 8, 10].indexOf(i) >= 0 ? '-' : '') + ('0' + b.toString(16)).slice(-2); }).join(''); },
            download: function (path) { return $http.get(root + path, {responseType: 'arraybuffer'}).then(function (r) { return r.data; }); },
            downloadPost: function (path, body) { return $http.post(root + path, body, {responseType: 'arraybuffer'}).then(function (r) { return r.data; }); },
            get: function (path, params) { return $http.get(root + path, {params: params}).then(function (r) { return r.data; }); },
            post: function (path, body) { return $http.post(root + path, body).then(function (r) { return r.data; }); },
            put: function (path, body) { return $http.put(root + path, body).then(function (r) { return r.data; }); },
            remove: function (path) { return $http.delete(root + path); }
        };
    }
})();
